module.exports = __webpack_public_path__ + "static/media/recurring_shred.3b1dabfa.png";